<template>
  <div class="main-content" ref="sub">
    <vxe-toolbar size="mini">
      <template v-slot:buttons>
        <template v-for="item in menuButtonList">
          <vxe-button
            type="primary"
            :icon="item.attributes.buttonStyle"
            :style="
              'background-color:' +
              (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)') +
              ';border:1px solid ' +
              (item.label == '删除' || item.label == '禁用' ? '#FE8783' : 'rgb(98, 153, 254)')
            "
            :key="item.id"
            :disabled="item.isDisabled"
            @click="chooseClick(item.attributes.buttonUrl, item)"
            >{{ item.label }}</vxe-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      keep-source
      :loading="load"
      :auto-resize="true"
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'row' }"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column type="index" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column field="balanceType" :title="$t('computationalFormula.table.balanceType')">
        <template slot-scope="scope">
          <span>
            {{ $baseRequest.getDictValueByType('balance_type', scope.row['balanceType']) }}
          </span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="formulaExpression"
        :title="$t('computationalFormula.table.formulaExpression')"
        :edit-render="clear"
      ></vxe-table-column>
      <vxe-table-column
        field="formulaStatus"
        :title="$t('computationalFormula.table.formulaStatus')"
      >
        <template slot-scope="scope">
          <span>
            {{
              scope.row['formulaStatus'] == '0'
                ? $t('computationalFormula.msg.ineffective')
                : $t('computationalFormula.msg.effective')
            }}
          </span>
        </template>
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/customerBalance/customerBalance';
  export default {
    name: 'computationalFormula',
    components: {},
    data() {
      return {
        menuButtonList: [], // 按钮
        load: false,
        tableData: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      clear() {
        return {
          name: 'ElInput',
          props: { clearable: true, maxlength: '32' },
        };
      },
    },
    created() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      //获取数据
      getData() {
        this.$axios.post(API.QUERY_FORMULA_LIST, {}).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      chooseClick(type) {
        if (type == 'save') {
          this.handleSave();
        } else if (type == 'enable' || type == 'disable') {
          this.handleOperate(type);
        }
      },
      handleSave() {
        let editData = this.$refs.xTable.getUpdateRecords();
        this.$axios.post(API.SAVE_FORMULA, editData).then((res) => {
          if (0 != res.data.code) {
            this.$alert(res.data.msg);
          } else {
            this.getData();
            this.$message({
              showClose: true,
              message: res.data.msg || this.$t('message.success'),
              type: 'success',
            });
          }
        });
      },
      handleOperate(type) {
        // 启用禁用计算配置公式
        if (this.multipleSelection.length == 0) {
          return this.$message({
            showClose: true,
            type: 'info',
            message: this.$t('message.noData'),
          });
        }
        let ids = this.multipleSelection.map((item) => {
          return item.id;
        });

        this.$confirmAction(
          this.$t(
            `computationalFormula.msg.${type == 'enable' ? 'enableConfirm' : 'disableConfirm'}`
          ),
          this.$t(`computationalFormula.msg.${type == 'enable' ? 'isEnable' : 'isDisable'}`)
        )
          .then(() => {
            this.commonRequest(type == 'enable' ? 'ENABLE_FORMULA' : 'DISABLE_FORMULA', ids);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      commonRequest(apiName, params) {
        this.loading.startLoading();
        this.$axios.post(API[apiName], params).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      getButtonList() {
        //获取菜单按钮
        this.getButtons().then((res) => {
          this.menuButtonList = res;
        });
      },
      handleSelectionChange(val) {
        // 选中事件
        this.multipleSelection = val.selection;
        if (this.multipleSelection.length == 0)
          return this.menuButtonList.forEach((item) => {
            item.isDisabled = false;
          });
        let flag1 = this.multipleSelection.every((item) => {
          return item.formulaStatus == '1';
        });
        let flag2 = this.multipleSelection.every((item) => {
          return item.formulaStatus == '0';
        });

        if (flag1) {
          this.menuButtonList.forEach((item) => {
            if (item.attributes.buttonUrl === 'enable') {
              item.isDisabled = true;
            } else {
              item.isDisabled = false;
            }
          });
        } else if (flag2) {
          this.menuButtonList.forEach((item) => {
            if (item.attributes.buttonUrl == 'disable') {
              item.isDisabled = true;
            } else {
              item.isDisabled = false;
            }
          });
        } else {
          this.menuButtonList.forEach((item) => {
            if (item.attributes.buttonUrl == 'enable' || item.attributes.buttonUrl == 'disable') {
              item.isDisabled = true;
            }
          });
        }
      },
    },
  };
</script>
